export const themePageCountryAnaly = {
    title:
        '比較する国名を最大5国まで選択してください。選択した国が属しているクラスタが表示され、スコア等を比較することができます。',
    metric: '表示データ',
    select1: 'スコア（技術競争力）',
    select2: 'スコア（平均値）',
    select3: '特許出願数',
    select4: '被引用数（合計）',
    select5: '平均被引用数（特許ベース）',
    select6: '平均被引用数（企業ベース）',
    select7: '被引用数（上位N平均）',
    select8: '重要特許数',
    select9: '重要特許率',
    topNModePercent: '割合(%)',
    topNModeCount: '固定値',
    topNUnitCompany: '社',
    countryPlaceholder: '国名を英語で入力してください',
    countryName: '国名を選択',
    tableColumn1: 'クラスタID',
    tableColumn2: 'クラスタ名',
    noDataMsg: '該当国はこのクラスタのデータがありません'
}
